import { FormCheckbox, FormInput, FormTextarea } from 'src/shared/components/FormComponents'
import { Column } from 'src/shared/components/Semantic/all'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from 'src/shared/components/ui/card'
import { UseFormReturn } from 'react-hook-form'
import { FormData } from '../types'

export const Recommendation = ({ methods }: { methods: UseFormReturn<FormData> }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Recommendation</CardTitle>
      </CardHeader>
      <CardContent>
        <Column className="gap-4">
          <FormCheckbox
            label="Klayder recommends"
            name="klayder_recommends"
            methods={methods}
          />
          <FormTextarea
            placeholder="Enter klayder recommendation text"
            name="klayder_recommendation_text"
            methods={methods}
            rows={6}
            className="w-full"
          />
          <FormInput
            placeholder="Enter related art nr."
            name="related_product_ids"
            methods={methods}
            type="text"
            className="w-1/2"
          />
        </Column>
      </CardContent>
    </Card>
  )
}

